<template>
  <a
    class="action-button"
    :class="[
      `action-button--theme-${theme}`,
      {
        'action-button-ac': ac,
        'action-button-disabled': disabled
      }
    ]"
    @click="onClick"
  >
    <span><slot></slot></span>
  </a>
</template>

<script>
  import {mapState} from "vuex"

  export const ThemeEnum = {
    DARK_FULL: 'dark_full',
    DARK_BORDERED: 'dark_bordered',
    LIGHT_FULL: 'light_full',
    LIGHT_BORDERED: 'light_bordered'
  };

  export default {
    props: {
      theme: {
        type: String,
        default: ThemeEnum.DARK_FULL
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapState({
        ac: state => state.ac
      })
    },
    methods: {
      onClick() {
        if (!this.disabled) {
          this.$emit('click');
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .action-button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    border: 1px solid transparent;
    border-radius: 26px;
    text-align: center;
    font-family: timsans_regular;
    font-size: 0.9375rem;
    line-height: normal;
    cursor: pointer;
    box-sizing: border-box;
    user-select: none;
  }

  /* theme light full */

  .action-button.action-button--theme-light_full {
    background-color: #FFFFFF;
    border-color: #FFFFFF;
    color: #003091;
    transition: background-color 0.4s ease;
  }

  .action-button.action-button--theme-light_full:active {
    background-color: rgba(#FFFFFF, 0.7);
  }

  .action-button-ac.action-button.action-button--theme-light_full {
    background-color: #FFFF00;
    border-color: #FFFF00;
    color: #1C1C1C;
  }

  .action-button-ac.action-button.action-button--theme-light_full:active {
    background-color: rgba(#FFFF00, 0.7);
  }

  /* theme light bordered */

  .action-button.action-button--theme-light_bordered {
    background-color: transparent;
    border-color: #FFFFFF;
    color: #FFFFFF;
    transition: background-color 0.4s ease;
  }

  .action-button.action-button--theme-light_bordered:active {
    background-color: rgba(#FFFFFF, 0.2);
  }

  .action-button-ac.action-button.action-button--theme-light_bordered {
    background-color: transparent;
    border-color: #FFFF00;
    color: #FFFF00;
    transition: background-color 0.4s ease;
  }

  .action-button-ac.action-button.action-button--theme-light_bordered:active {
    background-color: rgba(#FFFF00, 0.2);
  }

  /* theme dark full */

  .action-button.action-button--theme-dark_full {
    background-color: #003091;
    border-color: #003091;
    color: #FFFFFF;
    transition: background-color 0.4s ease;
  }

  .action-button.action-button--theme-dark_full:active {
    background-color: rgba(#003091, 0.7);
  }

  .action-button-disabled.action-button.action-button--theme-dark_full {
    background-color: transparent;
    border-color: #B3B3B3;
    color: #B3B3B3;
    cursor: default;
  }

  .action-button-ac.action-button.action-button--theme-dark_full {
    background-color: #FFFF00;
    border-color: #FFFF00;
    color: #1C1C1C;
  }

  .action-button-ac.action-button.action-button--theme-dark_full:active {
    background-color: rgba(#FFFF00, 0.7);
  }

  .action-button-ac.action-button-disabled.action-button.action-button--theme-dark_full {
    background-color: transparent;
    border-color: #FFFF00;
    color: #FFFF00;
    cursor: default;
  }

</style>